module.exports = __webpack_public_path__ + "static/media/thumbnail.463c54f5.jpg";